import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.css']
})
export class TermsPageComponent implements OnInit {
conditions: any;
generales: any;

  constructor() { }

  ngOnInit(): void {
  }

}
